import gql from 'graphql-tag';






const updateAssetTagsMutation = gql`
  mutation UpdateAssetTags($input: [UpdateAssetsTagsInput]!) {
    updateAssetsTags(input: $input) {
      assetId,
      tags
    }
  }
`;

const updateAssetTags = {
  mutation: updateAssetTagsMutation,
  module: 'assets',
  buildVariables: (input) => ({ input })
};

export default updateAssetTags;